export default __webpack_public_path__ + "static/media/link.28f38355.svg";